import { render } from "./title2.vue?vue&type=template&id=61e9d3d4"
import script from "./title2.vue?vue&type=script&lang=js"
export * from "./title2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__